/*
   Using by npm start
*/

// import { ApiUrlConstants } from '../services/api/apiUrl.constants';
// const preloadImgDir = ApiUrlConstants.PreLoadImage.ImageDirEndPoint;

// export const preLoadImagePath = {
//    vippsInfo: `${process.env.PUBLIC_URL}/images/img1.png`,
//    cctv: `${process.env.PUBLIC_URL}/images/cctv.svg`,
//    mobile: `${process.env.PUBLIC_URL}/images/mobile-with-scaner.png`,
//    loader: `${process.env.PUBLIC_URL}/images/t-loder.gif`,
//    successLoader: `${process.env.PUBLIC_URL}/images/success-loader.gif`,
//    ladyCharacter: `${process.env.PUBLIC_URL}/images/lady_character.png`,
//    qrCodeScan: `${process.env.PUBLIC_URL}/images/qr-code_img.svg`
// };

// export const preLoadImagePath = {
//     vippsInfo: preloadImgDir + 'img1.png',
//     cctv: preloadImgDir + 'cctv.svg',
//     mobile: preloadImgDir + 'mobile-with-scaner.png',
//     loader: preloadImgDir + 't-loder.gif',
//     successLoader: preloadImgDir + 'success-loader.gif',
//     ladyCharacter: preloadImgDir + 'lady_character.png',
//     qrCodeScan: preloadImgDir + 'qr-code_img.svg',
//     preloadImgDir: preloadImgDir
// };


/*
   Using by npm parcel public/index.html
*/

// const preloadImgDir = require.context('../../public/images', true);
// //const preloadImgDir = require.context('../../public/images', true, /\.(png|jpe?g|svg)$/);

//  import img1 from "../../public/images/img1.png";
//  import mobilewithscaner from "../../public/images/mobile-with-scaner.png";
//  import tloder from "../../public/images/t-loder.gif";
//  import successloader from "../../public/images/success-loader.gif";
//  import ladycharacter from "../../public/images/lady_character.png";
//  import qrcodeimg from "../../public/images/qr-code_img.svg";
//  import cctv from "../../public/images/cctv.svg";

//  export const preLoadImagePath = {
//     vippsInfo: img1,
//     cctv: cctv,
//     mobile: mobilewithscaner,
//     loader: tloder,
//     successLoader: successloader,
//     ladyCharacter: ladycharacter,
//     qrCodeScan: qrcodeimg
//  };
//const preloadImgDir = require.context('../../images', true);
import vippsInfo from "../assets/images/img1.png";
import cctv from '../assets/images/cctv.svg';
import mobile from '../assets/images/mobile-with-scaner.png';
import loader from '../assets/images/t-loder.gif';
import successLoader from '../assets/images/success-loader.gif';
import ladyCharacter from '../assets/images/lady_character.png';
import qrCodeScan from '../assets/images/qr-code_img.svg';

export const preLoadImagePath = {
    vippsInfo,
    cctv,
    mobile,
    loader,
    successLoader,
    ladyCharacter,
    qrCodeScan,
};
